import { InputWithLabel, SelectWithLabel } from '@adotel/components'
import { MenuItem, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { memo } from 'react'

import PageHeader from '../../components/PageHeader'
import { convertPersianNumbersToEnglishNumbers } from '../../helpers/numbers'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { ROLE } from '../../staticRoleManagement/types'
import useStyles from './styles/ChannelHeader.style'

interface ChannelHeaderProps {
  searchInputValue: string
  setSearchInputValue: (v: string) => void
  selectedChannelType: string
  setSelectedChannelType: React.Dispatch<React.SetStateAction<string>>
}

const ChannelHeader: React.FC<ChannelHeaderProps> = ({
  searchInputValue,
  setSearchInputValue,
  selectedChannelType,
  setSelectedChannelType
}) => {
  const classes = useStyles()

  const options = [
    'All',
    'TravelAgent',
    'HotelReservationOffice',
    'CentralReservationOffice'
  ]

  return (
    <div>
      <div className={classes.header}>
        <PageHeader title={getTranslate('Channel Selection')} />
        <Typography variant="h3" gutterBottom>
          {getTranslate('Channel Selection')}
        </Typography>
      </div>
      <div className={classes.filters}>
        <SelectWithLabel
          fullWidth
          value={selectedChannelType}
          onChange={(event: { target: { value: any } }) =>
            setSelectedChannelType(event.target.value)
          }
          noHelperText
          label={getTranslate('Channel Type')}
          size="small"
          disabled={getRoleFromStorage() === ROLE.ACCOMMODATION_OPERATOR}>
          {options.map((rt) => (
            <MenuItem key={rt} value={rt}>
              {getTranslate(rt)}
            </MenuItem>
          ))}
        </SelectWithLabel>
        <div className={classes.inputContainer}>
          <InputWithLabel
            placeholder={getTranslate('Search in channel names')}
            autoComplete="off"
            noHelperText
            fullWidth
            inputSize="small"
            startIcon={<SearchIcon />}
            value={searchInputValue}
            onChange={(event) => {
              setSearchInputValue(
                convertPersianNumbersToEnglishNumbers(event.currentTarget.value)
              )
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(ChannelHeader)
